/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { AnyNonRedactedAutoTestStepAsJSON } from './AnyNonRedactedAutoTestStepAsJSON';
import { CodeQualityExtra } from './CodeQualityExtra';
const CodeQualityAsJSONParser = 
/* #__PURE__ */ /* #__PURE__ */ codec.intersect(CodeQualityExtra, AnyNonRedactedAutoTestStepAsJSON);
export class CodeQualityAsJSON extends AnyNonRedactedAutoTestStepAsJSON {
    static decode(input) {
        return CodeQualityAsJSONParser.decode(input).map(res => new CodeQualityAsJSON(res));
    }
    static unsafeDecode(input) {
        return CodeQualityAsJSON.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return CodeQualityAsJSONParser.encode(data);
    }
    static schema() {
        return CodeQualityAsJSONParser.schema();
    }
}
